import { render, staticRenderFns } from "./scatterChart.vue?vue&type=template&id=1fd9bbdf&scoped=true"
import script from "./scatterChart.vue?vue&type=script&lang=js"
export * from "./scatterChart.vue?vue&type=script&lang=js"
import style0 from "./scatterChart.vue?vue&type=style&index=0&id=1fd9bbdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd9bbdf",
  null
  
)

export default component.exports